import { parseBoolean } from '@chatwoot/utils';

const {
  API_CHANNEL_NAME: apiChannelName,
  API_CHANNEL_THUMBNAIL: apiChannelThumbnail,
  APP_VERSION: appVersion,
  AZURE_APP_ID: azureAppId,
  BRAND_NAME: brandName,
  CHATWOOT_INBOX_TOKEN: chatwootInboxToken,
  CREATE_NEW_ACCOUNT_FROM_DASHBOARD: createNewAccountFromDashboard,
  DIRECT_UPLOADS_ENABLED: directUploadsEnabled,
  DISPLAY_MANIFEST: displayManifest,
  GIT_SHA: gitSha,
  HCAPTCHA_SITE_KEY: hCaptchaSiteKey,
  INSTALLATION_NAME: installationName,
  LOGO_THUMBNAIL: logoThumbnail,
  // NOTICE: KAPTION-INTEGRATION - rumo-rebrand.IDENTITY.1
  LOGO_THUMBNAIL_DARK: logoThumbnailDark,
  LOGO: logo,
  LOGO_DARK: logoDark,
  PRIVACY_URL: privacyURL,
  IS_ENTERPRISE: isEnterprise,
  TERMS_URL: termsURL,
  WIDGET_BRAND_URL: widgetBrandURL,
  DISABLE_USER_PROFILE_UPDATE: disableUserProfileUpdate,
  DEPLOYMENT_ENV: deploymentEnv,
  AI_STUDIO_URL: aiStudioUrl,
  // NOTICE: KAPTION-INTEGRATION
  KAPTION_COPILOT_URL: kaptionCopilotUrl,
  // NOTICE: KAPTION-INTEGRATION - dev-only 2FA nudge suppression. The server only ever
  // sets this when Rails.env.development? (DashboardController#skip_2fa_nudge?).
  KAPTION_SKIP_2FA_NUDGE: kaptionSkip2faNudge,
} = window.globalConfig || {};

const state = {
  apiChannelName,
  apiChannelThumbnail,
  appVersion,
  azureAppId,
  brandName,
  chatwootInboxToken,
  deploymentEnv,
  createNewAccountFromDashboard,
  directUploadsEnabled: parseBoolean(directUploadsEnabled),
  disableUserProfileUpdate: parseBoolean(disableUserProfileUpdate),
  displayManifest,
  gitSha,
  hCaptchaSiteKey,
  installationName,
  logo,
  logoDark,
  logoThumbnail,
  // NOTICE: KAPTION-INTEGRATION - rumo-rebrand.IDENTITY.1
  logoThumbnailDark,
  privacyURL,
  termsURL,
  widgetBrandURL,
  isEnterprise: parseBoolean(isEnterprise),
  aiStudioUrl,
  // NOTICE: KAPTION-INTEGRATION
  kaptionCopilotUrl,
  kaptionSkip2faNudge: parseBoolean(kaptionSkip2faNudge),
};

export const getters = {
  get: $state => $state,
  isOnChatwootCloud: $state => $state.deploymentEnv === 'cloud',
  isACustomBrandedInstance: $state => $state.installationName !== 'Chatwoot',
  isAChatwootInstance: $state => $state.installationName === 'Chatwoot',
  // Kaption AI specific getters
  isKaptionInstance: $state => $state.installationName === 'Kaption AI',
  isKaptionBrandingEnabled: $state => {
    // Check if Kaption branding is enabled via installation name or feature flag
    return (
      $state.installationName === 'Kaption AI' ||
      (window.chatwootConfig && window.chatwootConfig.kaptionBranding)
    );
  },
  getBrandName: $state => {
    if ($state.installationName === 'Kaption AI') {
      return 'Kaption AI';
    }
    return $state.brandName || 'Chatwoot';
  },
  getBrandUrls: $state => {
    if ($state.installationName === 'Kaption AI') {
      return {
        brandURL: 'https://www.kaptionai.com',
        widgetBrandURL: 'https://www.kaptionai.com',
        termsURL: 'https://www.kaptionai.com/terms-of-service.html',
        privacyURL: 'https://www.kaptionai.com/terms-of-service.html',
      };
    }
    return {
      brandURL: $state.brandURL || 'https://www.kaptionai.com',
      widgetBrandURL: $state.widgetBrandURL || 'https://www.kaptionai.com',
      termsURL: $state.termsURL,
      privacyURL: $state.privacyURL,
    };
  },
};

export const actions = {};

export const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
